import { useEffect, useState } from "react";
import api from "../../storage/api";
import DownloadDialog from "../DownloadDialog/DownloadDialog";
import { preactStorage } from "../../storage/preact";

const Hero = (props) => {
  const siteContent = props.content;
  const [serverOnline, setServerOnline] = useState(props.content.online);
  const [modalDownload, setModalDownload] = useState(false);
  const links = preactStorage.launcherLinks;

  useEffect(() => {
    const getOnline = async () => {
      const response = await fetch(api.apiPath + "&path=online");

      if (!response.ok) {
        console.log("Произошла ошибка при загрузке данных...");
      } else {
        const data = await response.json();
        setServerOnline(data);
      }
    };
    const id = setInterval(function () {
      getOnline();
    }, 30 * 1000);

    return () => {
      clearInterval(id);
    };
  }, []);

  return (
    <>
      <section
        className="hero"
        style={{
          background: `url(${api.apiImages}${siteContent.background}) no-repeat center center/cover`,
        }}
      >
        <div className="container">
          <div className="hero-wrapper">
            <div className="hero-image">
              <img src={`${api.apiImages}${siteContent.hero}`} className="hero-image__src" alt="RPMserver" />
            </div>
            <div className="hero-content">
              {serverOnline.status ? (
                <span className="hero-online">
                  <p className="hero-online__text">
                    Мы в сети.{" "}
                    <span>
                      Онлайн: {serverOnline.online}/{serverOnline.total}
                    </span>
                  </p>
                </span>
              ) : (
                <span className="hero-online hero-online_offile">
                  <p className="hero-online__text">
                    Сервер <span>оффлайн</span>
                  </p>
                </span>
              )}
              <p className="hero-content__description">{siteContent.hero_title}</p>
              <p className="hero-content__version">{siteContent.hero_subtitle}</p>
              <div className="hero-ip">
                {links && (
                  <button type="button" className="hero-ip__copy" onClick={() => setModalDownload((state) => !state)}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                      <path d="M638.6 368.2L605.2 156.6c-8.844-50.25-48.42-90.77-100.7-103.1C454.3 41.63 371.6 32 320 32C268.4 32 185.7 41.63 135.5 53.48C83.16 65.84 43.63 106.3 34.78 156.6l-33.38 211.6c-10.31 58.52 37.41 111.8 100.1 111.8c49.69 0 93.78-30.06 109.5-74.64l7.5-21.36h203l7.5 21.36c15.72 44.58 59.81 74.64 109.5 74.64C601.2 479.1 648.9 426.7 638.6 368.2zM247.1 248L215.1 247.1L215.1 280c0 13.2-10.78 24-23.97 24c-13.2 0-24.03-10.8-24.03-24l.0371-32.01L135.1 248C122.8 248 111.1 237.2 111.1 224c0-13.2 10.77-24 23.97-24l32.04-.0117L167.1 168c0-13.2 10.82-24 24.03-24c13.2 0 23.97 10.8 23.97 24l.0371 31.99L247.1 200c13.2 0 24.03 10.8 24.03 24C271.1 237.2 261.2 248 247.1 248zM432 311.1c-22.09 0-40-17.92-40-40c0-22.08 17.91-40 40-40s40 17.92 40 40C472 294.1 454.1 311.1 432 311.1zM496 215.1c-22.09 0-40-17.92-40-40c0-22.08 17.91-40 40-40s40 17.92 40 40C536 198.1 518.1 215.1 496 215.1z" />
                    </svg>
                    Скачать лаунчер
                  </button>
                )}

                <button
                  type="button"
                  className="hero-ip__copy hero-ip__copy_ip"
                  onClick={() => {
                    navigator.clipboard.writeText("play.rpmserver.com").then(() => {
                      alert("IP скопирован!");
                    });
                  }}
                >
                  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M9.60461 0C8.22571 0 7.10461 1.12109 7.10461 2.5V11.25C7.10461 12.6289 8.22571 13.75 9.60461 13.75H18.3546C19.7335 13.75 20.8546 12.6289 20.8546 11.25V2.5C20.8546 1.12109 19.7335 0 18.3546 0H9.60461ZM3.35461 6.25C1.97571 6.25 0.854614 7.37109 0.854614 8.75V17.5C0.854614 18.8789 1.97571 20 3.35461 20H12.1046C13.4835 20 14.6046 18.8789 14.6046 17.5V15H12.7296V17.5C12.7296 17.8438 12.4484 18.125 12.1046 18.125H3.35461C3.01086 18.125 2.72961 17.8438 2.72961 17.5V8.75C2.72961 8.40625 3.01086 8.125 3.35461 8.125H5.85461V6.25H3.35461Z"
                      fill="white"
                    />
                  </svg>
                  play.rpmserver.com
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <DownloadDialog active={modalDownload} setActive={setModalDownload} />
    </>
  );
};

export default Hero;
